import * as queries from '@queries/utils';

export const createUpload = (upload) => queries.postQuery('/api/upload', upload, false);

export const deleteUpload = (uploadToDelete) => queries.deleteQuery(`/api/upload/files`, uploadToDelete);